<template>
  <section>
    <div class="toolbar">
      <button class="button field is-primary" @click="create">
        <b-icon icon="plus"/>
        <span>New</span>
      </button>
      <b-input
        type="search"
        class="search-input"
        placeholder="Search"
        v-model="q"
        :autofocus="'autofocus'"
      />
    </div>
    <b-table :data="filteredProjects" :loading="loading" striped>
      <template slot-scope="props">
        <b-table-column label="Name">
          <router-link :to="`/projects/${props.row.id}/edit`">{{ props.row.name }}</router-link>
        </b-table-column>
        <b-table-column label="Enabled" centered>
          <a
            :class="['button', 'enable-button',
              props.row.enabled ? 'is-success' : 'is-danger',
              { 'is-loading': togglingProjectId === props.row.id }]"
            @click.prevent="toggleEnable(props.row.id)"
          >{{ props.row.enabled ? 'Yes' : 'No' }}</a>
        </b-table-column>
        <b-table-column label="Domains">{{ props.row.domain.join(', ') }}</b-table-column>
        <b-table-column :width="300">
          <a :href="`http://${props.row.domain[0]}/initialize`" target="_blank">
            <button class="button">Initialize</button>
          </a>
          <a @click="flushCache(props.row.domain[0])">
            <button class="button">Flush Cache</button>
          </a>
          <a @click="flushGameCache(props.row.domain[0])">
            <button class="button">Flush Game Cache</button>
          </a>
          <router-link :to="`/projects/${props.row.id}/edit`">
            <button class="button">Edit</button>
          </router-link>
          <button class="button" @click="toggleDuplicateModal(props.row.id)">Duplicate</button>
        </b-table-column>
      </template>
      <template slot="empty" v-if="!loading">
        <empty/>
      </template>
    </b-table>
    <b-modal :active.sync="isDuplicateModalOpened" has-modal-card>
      <duplicate-form :projectId="duplicatedProjectId"/>
    </b-modal>
  </section>
</template>

<script>
import DuplicateForm from './DuplicateForm'
import http from '@/lib/utils/http'
import Empty from '@/lib/components/Empty'
import axios from 'axios'

export default {
  data() {
    return {
      projects: [],
      loading: false,
      q: '',
      togglingProjectId: null,
      duplicatedProjectId: null,
      isDuplicateModalOpened: false,
    }
  },
  components: {
    DuplicateForm,
    Empty,
  },
  mounted() {
    if (localStorage.projects) {
      this.projects = JSON.parse(localStorage.projects)
    }
  },
  computed: {
    filteredProjects() {
      return this.projects
        .filter(p => p.name.includes(this.q) || p.domain.some(p => p.includes(this.q)))
        .sort((a, b) => b.id - a.id)
    },
  },
  methods: {
    flushCache(domain) {
      const one = http.get(`${domain}/init?s=1&config=Ed[MDB7X!MZn}Zd&type=main`)
      const two = http.get(`${domain}/init?s=2&config=Ed[MDB7X!MZn}Zd`)
      const three = http.get(`${domain}/init?s=3&config=Ed[MDB7X!MZn}Zd`)
      const loader = this.$loading.open()
      axios
        .all([one, two, three])
        .then(
          axios.spread((...repsonses) => {
            const responseOne = repsonses[0]
            const responseTwo = repsonses[1]
            const responesThree = repsonses[2]
            loader.close()
          })
        )
        .catch(e => {
          loader.close()
        })
    },
    flushGameCache(domain) {
      const one = http.get(`${domain}/init?s=1&config=Ed[MDB7X!MZn}Zd&type=games`)
      const two = http.get(`${domain}/init?s=2&config=Ed[MDB7X!MZn}Zd`)
      const three = http.get(`${domain}/init?s=3&config=Ed[MDB7X!MZn}Zd`)
      const loader = this.$loading.open()
      axios
        .all([one, two, three])
        .then(
          axios.spread((...repsonses) => {
            const responseOne = repsonses[0]
            const responseTwo = repsonses[1]
            const responesThree = repsonses[2]
            loader.close()
          })
        )
        .catch(e => {
          loader.close()
        })
    },
    create() {
      this.$router.push('/projects/new')
    },
    load(page = 1, projects = []) {
      http
        .get('projects', { params: { page } })
        .then(resp => {
          if (resp.data.length > 0) {
            projects = projects.concat(resp.data)
          }
          if (resp.data.length === 30) {
            this.load(page + 1, projects)
          } else {
            this.save(projects)
          }
        })
        .catch(() => {
          this.save(projects)
        })
    },
    save(projects) {
      this.projects = projects
      localStorage.projects = JSON.stringify(projects)
    },
    toggleEnable(projectId) {
      if (this.togglingProjectId) return

      const project = this.projects.find(p => p.id === projectId)
      if (!project) return

      const action = project.enabled ? 'disable' : 'enable'
      this.togglingProjectId = projectId

      http
        .put(`projects/${projectId}/${action}`)
        .then(resp => (project.enabled = resp.data.enabled))
        .catch(() => {})
        .then(() => (this.togglingProjectId = null))
    },
    toggleDuplicateModal(projectId) {
      this.isDuplicateModalOpened = true
      this.duplicatedProjectId = projectId
    },
  },
  created() {
    this.load()
  },
}
</script>

<style>
.toolbar {
  width: 300px;
  display: flex;
  justify-content: space-between;
}
.enable-button {
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/List/List.vue